import { z } from 'zod';

const options = ['battery', 'converter', 'solar', 'utility', 'panel', 'charger', 'generator'] as const;

export type PortPurposeOption = (typeof options)[number];

const validator = z.enum(options).nullable().default(null);

const PortPurpose = {
    validator,
    options,
};

export { PortPurpose };
